import AboutUsModule from 'components/about-us/AboutUsModule';
import AboutUsSiteContainer from 'components/about-us/AboutUsSiteContainer';
import { DaymadeDesignSystemPreviewComponentInfo } from '.';
import { useEffect, useRef, useState } from 'react';
import RoundedButton from 'components/RoundedButton';

const ComponentPreview = () => {
  const [measureUpdateCount, setMeasureUpdateCount] = useState(0);
  useEffect(() => {
    const interval = setInterval(
      () => setMeasureUpdateCount((x) => (x == 0 ? 0 : x + 1)),
      1000,
    );
    return () => {
      clearInterval(interval);
    };
  }, []);
  return (
    <AboutUsModule background="grey">
      <AboutUsSiteContainer>
        <h2 className="aboutUsTypographyHeaderXlarge">Typography</h2>
        <p>
          This page demonstrates various font sizes in the Daymade design
          system. The fonts change size on mobile vs desktop.
        </p>
        <p>
          <RoundedButton
            rebrandDm2025
            onClick={() =>
              setMeasureUpdateCount((x) => (x > 0 ? 0 : Math.random()))
            }
          >
            Show sizes
          </RoundedButton>
        </p>
        <h3 className="aboutUsTypographyHeaderXlargeOnTeal">
          Heading XL
          <MeasureFontSize measureUpdateCount={measureUpdateCount} />
        </h3>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua.
        </p>

        <h3 className="aboutUsTypographyHeaderXlargeOnWhite">
          Heading XL (with underline)
          <MeasureFontSize measureUpdateCount={measureUpdateCount} />
        </h3>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua.
        </p>

        <h3 className="aboutUsTypographyHeaderXlargeOnWhite aboutUsTypographyAltUnderlineColour">
          Heading XL (with underline, alt colour)
          <MeasureFontSize measureUpdateCount={measureUpdateCount} />
        </h3>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua.
        </p>
        <h3
          className="aboutUsTypographyHeaderXlargeOnWhite"
          style={{ width: '50%' }}
          data-text="Heading XL (only underline last line)"
        >
          Heading XL (only underline last line)
          <MeasureFontSize measureUpdateCount={measureUpdateCount} />
        </h3>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua.
        </p>

        <h3 className="aboutUsTypographyHeaderLarge">
          Heading Large
          <MeasureFontSize measureUpdateCount={measureUpdateCount} />
        </h3>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua.
        </p>

        <h3 className="aboutUsTypographyHeaderMedium">
          Heading Medium
          <MeasureFontSize measureUpdateCount={measureUpdateCount} />
        </h3>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua.
        </p>

        <p>
          Body text (default) - Lorem ipsum dolor sit amet, consectetur
          adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore
          magna aliqua.
          <MeasureFontSize measureUpdateCount={measureUpdateCount} />
        </p>
        <p className="aboutUsTypographyBodySmall">
          Body text small - Lorem ipsum dolor sit amet, consectetur adipiscing
          elit, sed do eiusmod tempor incididunt ut labore et dolore magna
          aliqua.
          <MeasureFontSize measureUpdateCount={measureUpdateCount} />
        </p>
        <p className="aboutUsTypographyCaption">
          <MeasureFontSize measureUpdateCount={measureUpdateCount} />
          Caption - Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
          do eiusmod tempor incididunt ut labore et dolore magna aliqua.
        </p>
      </AboutUsSiteContainer>
    </AboutUsModule>
  );
};

const MeasureFontSize = (props: { measureUpdateCount: number }) => {
  const ref = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    if (ref.current && ref.current.parentElement) {
      console.log(ref.current.parentElement, ref.current.offsetParent);

      const offsetParent = ref.current.offsetParent as HTMLElement;
      const thingWeWantToPositionAgainst = ref.current.parentElement;

      const computedStyle = window.getComputedStyle(ref.current.parentElement);
      const fontSize = computedStyle.fontSize;
      const lineHeightRatio =
        +computedStyle.lineHeight.replace('px', '') /
        +computedStyle.fontSize.replace('px', '');
      ref.current.innerText =
        fontSize +
        ', line height ' +
        lineHeightRatio +
        ' (' +
        computedStyle.lineHeight +
        ')';
      const differenceX =
        thingWeWantToPositionAgainst.offsetLeft -
        (offsetParent?.offsetLeft || 0);
      const differenceY =
        thingWeWantToPositionAgainst.offsetTop - (offsetParent?.offsetTop || 0);
      ref.current.style.left = differenceX + 'px';
      ref.current.style.top =
        differenceY + +computedStyle.lineHeight.replace('px', '') + 'px';
    }
  }, [props.measureUpdateCount]);

  return (
    <div
      ref={ref}
      style={{
        display: props.measureUpdateCount === 0 ? 'none' : undefined,
        borderRadius: 4,
        background: '#000',
        color: '#fff',
        padding: 4,
        position: 'absolute',
        top: -999,
        left: -999,
        fontSize: 10,
        textShadow: 'none',
        fontWeight: 'normal',
      }}
    ></div>
  );
};

ComponentPreview.daymadeDesignSystemInfo = {
  name: 'Typography',
} as DaymadeDesignSystemPreviewComponentInfo;

export default ComponentPreview;
